import React from "react";

interface ServerPaginationProps {
  page: number;
  totalPages: number;
  total: number;
  perPage: number;
  perPageOptions: number[];
  onPerPageChange: (perPage: number) => void;
  onPageChange: (page: number) => void;
}

/**
 * Fixed-bottom pagination bar for SERVER-paginated tables (Reference/FS61, Silver History) —
 * adds a rows-per-page select + editable page-jump box next to Prev/Next, mirroring the
 * client-paginated <Pagination> component's look.
 */
const ServerPagination: React.FC<ServerPaginationProps> = ({ page, totalPages, total, perPage, perPageOptions, onPerPageChange, onPageChange }) => {
  function jumpTo(value: string) {
    const n = parseInt(value, 10);
    if (!Number.isFinite(n)) return;
    onPageChange(Math.min(totalPages, Math.max(1, n)));
  }

  return (
    <div className="pagination-bar">
      <span>{total} rows</span>
      <div className="pagination-controls">
        <label>
          Rows per Page:{" "}
          <select value={perPage} onChange={(e) => onPerPageChange(parseInt(e.target.value, 10))}>
            {perPageOptions.map((n) => <option key={n} value={n}>{n}</option>)}
          </select>
        </label>
        <button disabled={page <= 1} onClick={() => onPageChange(Math.max(1, page - 1))}>&laquo; Prev</button>
        <span className="pg-jump">
          Page{" "}
          <input
            type="number" className="pg-page-input" min={1} max={totalPages} value={page}
            onChange={(e) => jumpTo(e.target.value)}
          />{" "}
          of {totalPages}
        </span>
        <button disabled={page >= totalPages} onClick={() => onPageChange(Math.min(totalPages, page + 1))}>Next &raquo;</button>
      </div>
    </div>
  );
};

export default ServerPagination;
